import { MenuItem, Select } from '@mui/material';
import { Utils } from 'app/main/components';

interface PhonceCallsChartYearSelectorProps {
	year: number;
	setYear: React.Dispatch<React.SetStateAction<number>>;
}

export function PhonceCallsChartYearSelector(props: PhonceCallsChartYearSelectorProps) {
	const currentYear = Utils.today().year();

	return (
		<Select variant="outlined" size="small" value={props.year} onChange={e => props.setYear(e.target.value)}>
			{Array.from(Array(3).keys()).map(index => (
				<MenuItem key={currentYear - index} value={currentYear - index}>
					{currentYear - index}
				</MenuItem>
			))}
		</Select>
	);
}
